import { DescribeProperty } from '../../common';

export class SubscriptionResponse {
  @DescribeProperty({
    description: `Email address`,
    example: 'mail@example.org',
    type: 'string',
  })
  email: string;

  @DescribeProperty({
    description: `Status`,
    example: 'subscribed',
    type: 'string',
  })
  status: string;
}
